var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTenancyContractTitleDeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1785 8.19593C24.1785 7.53902 23.9221 6.92062 23.4575 6.45599L21.1376 4.13604C20.6794 3.67781 20.029 3.41504 19.3817 3.41504H19.2407V8.33691H24.1786L24.1785 8.19593Z",
    fill: "url(#paint0_linear_4402_12187)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8579 20.3428C18.0149 19.8662 18.2889 19.4224 18.6461 19.0627L24.2003 13.5309V9.97754H18.4363C17.9828 9.97754 17.6426 9.61064 17.6426 9.15723V3.41504H5.33789C3.98088 3.41504 2.87695 4.51896 2.87695 5.87598V28.9541C2.87695 30.3111 3.98088 31.415 5.33789 31.415H21.7175C23.0745 31.415 24.2003 30.3111 24.2003 28.9541V22.8318L23.2989 23.7114C22.9336 24.0735 22.5058 24.337 22.0235 24.4981L19.4152 25.3688L19.0179 25.3905C18.361 25.3905 17.7393 25.0709 17.3532 24.5357C16.9703 24.003 16.8662 23.3125 17.0744 22.6884L17.8579 20.3428ZM6.97852 18.1807H15.155C15.6084 18.1807 15.9753 18.5476 15.9753 19.001C15.9753 19.4544 15.6084 19.8213 15.155 19.8213H6.97852C6.5251 19.8213 6.1582 19.4544 6.1582 19.001C6.1582 18.5476 6.5251 18.1807 6.97852 18.1807ZM6.1582 15.7197C6.1582 15.2663 6.5251 14.8994 6.97852 14.8994H15.155C15.6084 14.8994 15.9753 15.2663 15.9753 15.7197C15.9753 16.1731 15.6084 16.54 15.155 16.54H6.97852C6.5251 16.54 6.1582 16.1731 6.1582 15.7197ZM6.1582 22.2822C6.1582 21.8288 6.5251 21.4619 6.97852 21.4619H15.155C15.6084 21.4619 15.9753 21.8288 15.9753 22.2822C15.9753 22.7356 15.6084 23.1025 15.155 23.1025H6.97852C6.5251 23.1025 6.1582 22.7356 6.1582 22.2822ZM18.4363 26.3838C18.8897 26.3838 19.2566 26.7507 19.2566 27.2041C19.2566 27.6575 18.8897 28.0244 18.4363 28.0244H13.5144C13.061 28.0244 12.6941 27.6575 12.6941 27.2041C12.6941 26.7507 13.061 26.3838 13.5144 26.3838H18.4363ZM6.97852 13.2588C6.5251 13.2588 6.1582 12.8919 6.1582 12.4385C6.1582 11.9851 6.5251 11.6182 6.97852 11.6182H18.4363C18.8897 11.6182 19.2566 11.9851 19.2566 12.4385C19.2566 12.8919 18.8897 13.2588 18.4363 13.2588H6.97852Z",
    fill: "url(#paint1_linear_4402_12187)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3438 21.0684L18.6302 23.2094C18.5232 23.5302 18.8284 23.8353 19.1492 23.7281L21.289 23.0135L19.3438 21.0684Z",
    fill: "url(#paint2_linear_4402_12187)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.715 14.3145L20.3125 19.717L22.6425 22.0469C23.8635 20.8257 26.2394 18.4494 28.0447 16.6441L25.715 14.3145Z",
    fill: "url(#paint3_linear_4402_12187)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3948 11.9617C30.1064 11.6717 29.6818 11.5059 29.2316 11.5059C28.7813 11.5059 28.3568 11.6717 28.0668 11.9625L26.8748 13.1545L29.2043 15.4841C29.8569 14.8315 30.308 14.3804 30.3965 14.292C31.0372 13.6502 31.0372 12.6049 30.3948 11.9617Z",
    fill: "url(#paint4_linear_4402_12187)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3965 14.2924L30.3967 14.2923C30.3987 14.2902 30.3997 14.2893 30.4014 14.2876C30.3997 14.2893 30.3987 14.2903 30.3965 14.2924Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4013 14.2875C30.4039 14.2849 30.407 14.2819 30.4086 14.2803C30.4069 14.2819 30.4039 14.2849 30.4013 14.2875Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4086 14.2804C30.4139 14.2751 30.414 14.275 30.4086 14.2804V14.2804Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4402_12187",
    x1: 21.7096,
    y1: 3.49423,
    x2: 21.7096,
    y2: 7.96593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4402_12187",
    x1: 13.5383,
    y1: 3.86555,
    x2: 13.5383,
    y2: 29.3046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4402_12187",
    x1: 19.9487,
    y1: 21.1115,
    x2: 19.9487,
    y2: 23.5479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4402_12187",
    x1: 24.1785,
    y1: 14.4389,
    x2: 24.1785,
    y2: 21.4641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4402_12187",
    x1: 28.8757,
    y1: 11.5699,
    x2: 28.8757,
    y2: 15.1842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2223,
    stopColor: "#FF84AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#FF6DA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF498B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenancyContractTitleDeed);
export default __webpack_public_path__ + "static/media/Tenancy Contract & Title Deed.b5504d4f9b053ce8a3a3677cb629ef9c.svg";
export { ForwardRef as ReactComponent };